<template>
  <v-app>
    <v-row v-if="academic_class">
      <v-col md="3" cols="12">
        <v-card flat>
          <v-card-title class="justify-center">
            Class Summary - {{ academic_class.title }}
          </v-card-title>
          <v-card-text>
            <div class="text-center" v-if="academic_class">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="font-weight-bold mr-2">Class/Section</span>
                <strong class="heading">{{ academic_class.title }}</strong>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="font-weight-bold mr-2">Unique number</span>
                <strong class="heading">{{ academic_class.unique_no ? academic_class.unique_no : '' }}</strong>
              </div>

              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="font-weight-bold mr-2">Program</span>
                <strong class="heading">{{ academic_class.program.title }}</strong>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="font-weight-bold mr-2">Semester/Year</span>
                <strong class="heading">{{ academic_class.grade.title }}</strong>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="font-weight-bold mr-2">Batch</span>
                <strong class="heading">{{ academic_class.academic_year.title }}</strong>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="font-weight-bold mr-2">Shift</span>
                <strong class="heading">{{ academic_class.shift }}</strong>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="font-weight-bold mr-2">Start date</span>
                <strong class="heading">{{ academic_class.start_date }}</strong>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="font-weight-bold mr-2">End date</span>
                <strong class="heading">{{ academic_class.end_date }}</strong>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="font-weight-bold mr-2">Total assigned students</span>
                <strong class="heading">{{ assigned_students_count || 0 }}</strong>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="font-weight-bold mr-2">Total assigned teachers</span>
                <strong class="heading">{{ academic_class.total_assigned_teacher || 0 }}</strong>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="font-weight-bold mr-2">Total class taken</span>
                <strong class="heading">{{ academic_class.teacher_total_class_taken }}</strong>
              </div>
            </div>
            <v-tabs class="menu-parent" vertical v-model="model">
              <v-tab>
                <v-icon left>
                  fas fa-user-graduate
                </v-icon>
                Students
              </v-tab>

              <!--                            <v-tab>-->
              <!--                                <v-icon left>-->
              <!--                                    fas fa-calendar-check-->
              <!--                                </v-icon>-->
              <!--                                Time Table-->
              <!--                            </v-tab>-->
              <v-tab>
                <v-icon left>
                  far fa-calendar-check
                </v-icon>
                Take attendance
              </v-tab>
              <v-tab>
                <v-icon left>
                  far fa-calendar-alt
                </v-icon>
                Attendance report
              </v-tab>
              <v-tab>
                <v-icon left>
                  far fa-clipboard
                </v-icon>
                Exams
              </v-tab>
              <v-tab>
                <v-icon left>
                  fas fa-book-open
                </v-icon>
                Courses
              </v-tab>
            </v-tabs>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="9" cols="12">
        <v-tabs-items v-model="model">
          <v-tab-item>
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header">
                    <div class="card-title pt-3 px-3 d-flex justify-content-between">
                      <div class="breadcrumb-left">
                        <h4>
                          Students in this classroom
                        </h4>

                      </div>
                      <div class="breadcrumb-right">
                        <v-btn @click="exportStudent()"
                               class="mt-4 btn btn-primary  mr-1"
                               dark>
                          <i class="fa fa-file-export"></i>
                          Export student
                        </v-btn>

                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <students :class_id="classId"   @count_assigned_students="setCountAcademicStudent"></students>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="row mt-2" v-if="!academicClassTimetable.id">
              <div class="col-md-12 text-center">
                <v-card class="p-20">
                  <img src="@/assets/media/images/no-data-found.png">
                  <h5 class="mt-10">Attendance not available at the moment. Make sure you have set time table.</h5>
                </v-card>
              </div>
            </div>
            <attendance v-else :academic_class="academic_class" :timetable="academicClassTimetable"
                        :courses="teacher_assigned_courses"></attendance>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <attendance-report :academic_class="academic_class"
                                   :courses="teacher_assigned_courses"></attendance-report>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <exams  :class_id="classId"></exams>
          </v-tab-item>
          <v-tab-item>
            <courses :assigned_courses="assigned_courses"></courses>

          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

  </v-app>
</template>

<script>
import Courses from "./summary/Courses";
import Students from "./summary/Students";
import Attendance from "./summary/Attendance";
import Exams from "./summary/Exams";
import {API_URL} from "@/core/config";
import AttendanceReport from "@/view/pages/academic-class/summary/attendance/AttendanceReport";
import AcademicClassService from "@/core/services/academic-class/AcademicClassService";
import AcademicCLassTimetableService from "@/core/services/academicClassTimetable/AcademicCLassTimetableService";
import AcademicCLassTimetablePeriodService from "@/core/services/academicClassTimetablePeriod/AcademicCLassTimetablePeriodService";
import AttendanceService from "@/core/services/attendance/AttendanceService";
import ExamService from "@/core/services/exam/ExamService";
import AcademicClassTeacherService from "@/core/services/academic-class/class-teacher/AcademicClassTeacherService";

const academicClassService = new AcademicClassService();
const academicClassTeacherService = new AcademicClassTeacherService();
const attendance = new AttendanceService();
const academicClassTimetable = new AcademicCLassTimetableService();
const academicCLassTimetablePeriod = new AcademicCLassTimetablePeriodService();
const examService = new ExamService();
export default {
  name: "ClassroomSummary",
  components: {
    AttendanceReport,
    Courses,
    Students,
    Attendance,
    Exams
  },
  data() {
    return {
      model: 0,
      academic_class: null,
      assigned_students_count:null,
      assigned_teachers: [],
      assigned_courses: [],
      teacher_assigned_courses: [],
      attendanceReports: [],
      academicClassTeacherPeriods: [],

      academicClassTimetablePeriods: [],
      attendance: null,
      day_attendance_type: null,

      search: {
        // date: null,
        // academic_class_id: null,
        // time_table_id: null,
        // timetable_period_id: null,

        academic_class_id: null,
        day_attendance: false,
        time_table_id: "",
        timetable_period_id: "",
        level_id: null,
        program_id: null,
        academic_year_id: null,
        year: 2021,
        month: 5,
        grade_id: null
      },
      academicClassTimetable: {
        class_id: null,
        title: null,
        is_working_sunday: null,
        is_working_monday: null,
        is_working_tuesday: null,
        is_working_wednesday: null,
        is_working_thursday: null,
        is_working_friday: null,
        is_working_saturday: null,
        is_active: 0,
      },
      academicClassTimetablePeriod: {
        timetable_id: null,
        day: null,
        subject_id: null,
        subject_name: null,
        teacher_id: null,
        teacher_name: null,
        start_time: null,
        end_time: null,
        is_break: 0,
      },
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
    classId() {
      return this.$route.params.classId;
    }
  },
  mounted() {
    this.getClass();
  },
  methods: {
    assignCourse(academicClass) {
      this.$refs["assignCourse"].showModal(academicClass);
    },
    assignStudents(academicClass) {
      this.$refs["assignStudents"].showModal(academicClass);
    },

    openExamDialog(academic_class) {
      this.$refs["exam"].showModal({}, academic_class);
    },
    setCountAcademicStudent(data){
      this.assigned_students_count=data;
    },
    getClass() {
      academicClassService.show(this.classId).then((response) => {
        this.academic_class = response.data.class;
        this.getTimeTable()
        this.getAssignedTeacherCoursesList();
        this.getAssignedExams()
        this.getAssignedCourses()
        this.getAssignedStudents();
      }).catch(err => {
        // console.log(err)
      }).finally(() => {

      })
    },
   getAssignedStudents() {
     this.$refs['assigned_students_refresh'].countAssignStudentCount();
   },
    getAcademicTeacherPeriod() {
      academicCLassTimetablePeriod.getByClassAndTeacherId(this.classId, this.currentUser.id).then((resources) => {
        this.academicClassTeacherPeriods = resources.data.academicClassTimetablePeriod;
      }).catch(err => {
      })
    },

    getAssignedCourses() {
      academicClassService.getAssignedCourses(this.classId).then(response => {
        this.assigned_courses = response.data.courses;
        let courses = this.assigned_courses
      });
    },
    getTimeTable() {
      academicClassTimetable.getByClass(this.classId).then((response) => {
        this.academicClassTimetable = response.data.academicClassTimetable;
        this.getAcademicTimetablePeriod();
      })
    },
    getAcademicTimetablePeriod() {
      academicCLassTimetablePeriod.getByClassAndTeacherId(this.classId).then((resources) => {
        this.academicClassTimetablePeriods = resources.data.academicClassTimetablePeriod;
      }).catch(err => {
      })
    },


    // getAssignedTeacherCoursesList() {
    //   this.$bus.emit('toggleLoader');
    //   academicClassTeacherService.getCourseByTeacherId(this.currentUser.id).then(response => {
    //     let courses = response.data.courses;
    //     courses.forEach(ele => {
    //       let gradeTitle = ele.grade.title
    //       let course = ele.title
    //       ele.display_text = `${gradeTitle} | ${course}`
    //         this.teacher_assigned_courses.push(ele)
    //     })
    //   }).catch((err) => {
    //     // console.log(err)
    //   }).finally(() => {
    //     this.$bus.emit('toggleLoader');
    //   });
    // },
    getAssignedTeacherCoursesList() {
      this.$bus.emit('toggleLoader');
      academicClassTeacherService.getTeacherCoursesByClass(this.academic_class.id).then(response => {
        let courses = response.data.courses;
        courses.forEach(ele => {
          let gradeTitle = ele.grade.title
          let course = ele.title
          ele.display_text = `${gradeTitle} | ${course}`
            this.teacher_assigned_courses.push(ele)
        })
      }).catch((err) => {
        // console.log(err)
      }).finally(() => {
        this.$bus.emit('toggleLoader');
      });
    },
    exportStudent() {
      window.open(API_URL + `user/teacher/class/${this.academic_class.id}/student/export`, '_blank')
    },



  },
}
</script>

<style scoped>
.menu-parent .v-tab {
  justify-content: flex-start !important;
}
</style>
